<template>
  <b-navbar id="navbar-main" toggleable="lg" type="light" variant="primary" class="fixed-top" v-if="isHeaderShown">
    <!-- <div class="drawer-toggle ml-0" v-if="!isPublicRoute">
      <my-button fa="bars" label="" variant="header-toggle" classes="mr-1" @onClick="onClick"
        v-bind:class="{ 'd-none': searchBarOpen, 'd-lg-block': searchBarOpen }"></my-button>
    </div> -->
    <b-navbar-brand :href="this.$store.getters.instanceUrl + 'my/indexsys.php'" v-bind:class="{
      'd-none': searchBarOpen,
      'd-lg-block': searchBarOpen,
      'd-block': isPublicRoute,
    }">
      <img :src="applicationLogo" alt="" />
    </b-navbar-brand>

    <div class="wizard wizard-center" v-if="this.$route.name == 'CompanyMakePayment'">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="text-center"
          v-bind:class="[cpwStep == 1 ? 'active' : (completedcpwStep(1) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
            <span class="round-tab" id="step1">1 </span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.create_account_title) }}
          </div>
        </li>

        <li role="presentation" class="text-center"
          v-bind:class="[cpwStep == 2 ? 'active' : (completedcpwStep(2) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step2" role="tab" aria-expanded="true">
            <span class="round-tab" id="step2">2 </span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.select_suddomain_step_title) }}
          </div>
        </li>
        <li role="presentation" class="text-center"
          v-bind:class="[cpwStep == 3 ? 'active' : (completedcpwStep(3) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step3" role="tab" aria-expanded="true">
            <span class="round-tab" id="step3">3 </span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.payment_method) }}
          </div>
        </li>
      </ul>
    </div>

    <div class="wizard wizard-center" v-if="this.$route.name == 'CompanyWebshopPayment'">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="text-center"
          v-bind:class="[wpwStep == 1 ? 'active' : (completedwpwStep(1) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true">
            <span class="round-tab" id="step1">1</span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.your_order_heading) }}
          </div>
        </li>

        <li v-if="this.disabledStep.indexOf(2) == -1" role="presentation" class="text-center"
          v-bind:class="[wpwStep == 2 ? 'active' : (completedwpwStep(2) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step2" role="tab" aria-expanded="true">
            <span class="round-tab" id="step2">2</span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.create_or_signin_step_title) }}
          </div>
        </li>

        <li role="presentation" class="text-center"
          v-bind:class="[wpwStep == 3 ? 'active' : (completedwpwStep(3) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step3" role="tab" aria-expanded="true">
            <span class="round-tab" id="step3">{{ this.disabledStep.indexOf(2) != -1 ? 2 : 3 }}</span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.participants) }}
          </div>
        </li>

        <li role="presentation" class="text-center"
          v-bind:class="[wpwStep == 4 ? 'active' : (completedwpwStep(4) ? 'completed' : 'disabled')]">
          <a data-toggle="tab" aria-controls="step4" role="tab" aria-expanded="true">
            <!-- <span class="round-tab" id="step3">{{ isParticipantActionEnabled == true ? '4' : '3'}}</span> -->
            <span class="round-tab" id="step4">{{ this.disabledStep.indexOf(2) != -1 ? 3 : 4 }}</span>
          </a>
          <div class="step-title">
            {{ $t(LangConstants.payment_method) }}
          </div>
        </li>
      </ul>
    </div>

    <b-navbar-nav class="ml-auto" v-bind:class="{ 'right-nav': searchBarOpen }">
      <b-collapse id="searchform-navbar">
        <b-nav-form right @submit.prevent="">
          <b-input-group>
            <b-form-input @keyup.enter="handleInputOnEnter" type="text"
              :placeholder="$t(LangConstants.search_placeholder)" ref="searchBarInput"></b-form-input>
            <b-button v-b-toggle.searchform-navbar variant="light" class="btn-close" squared
              v-on:click="toggleSearchBar()"><i class="icon fa fa-times fa-fw" aria-hidden="true"></i></b-button>
          </b-input-group>
        </b-nav-form>
      </b-collapse>

      <b-button v-b-toggle.searchform-navbar variant="outline-secondary" squared class="search-btn mr-1"
        v-on:click="toggleSearchBar()" v-bind:class="{ active: searchBarOpen }" v-if="!isPublicRoute">
        <i class="icon fa fa-search fa-fw" aria-hidden="true"></i>
      </b-button>
      <b-nav-item-dropdown right no-caret v-bind:class="{ 'd-none': searchBarOpen, 'd-lg-block': searchBarOpen }"
        v-if="!isPublicRoute && menuItems">
        <template #button-content>
          <i class="fa fa-th menu-icon mt-1" aria-hidden="true"></i>
        </template>
        <div :class="menuItemContainerClass">
          <div class="row no-gutters" v-for="menuitemgroup in menuItems" :key="menuitemgroup.name">
            <div class="col-12 mt-3" v-if="menuitemgroup.name">
              <div class="dropdown-divider"></div>
            </div>
            <div class="col-12" v-if="menuitemgroup.name">
              <div class="menu-section-name">{{menuitemgroup.name}}</div>
            </div>
            <div :class="menuItemClass" v-for="menuitem in menuitemgroup.items" :key="menuitem.id">
              <a :href="getMenuItemUrl(menuitem.url)">
                <div>
                  <span class="menu-item-icon"><i :class="getMenuItemIcon(menuitem.fa_icon)"></i></span>
                  <span class="menu-item-text">{{menuitem.name}}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown right v-bind:class="{ 'd-none': searchBarOpen, 'd-lg-block': searchBarOpen }"
        v-if="!isPublicRoute">
        <template #button-content>
          <img v-if="authUserImage" :src="authUserImage" class="rounded-circle userpicture profile-pic-icon" />
          <span v-if="!authUserImage" class="userinitials size-35"> {{ userinitials }} </span>
        </template>
        <b-dropdown-item :href="this.$store.getters.instanceUrl + 'user/profile.php'"><i class="icon fa fa-user fa-fw"
            aria-hidden="true"></i>{{ $t(LangConstants.profile_dropdown_link_title) }}</b-dropdown-item>
        <b-dropdown-item :href="this.$store.getters.instanceUrl + '/login/logout.php'"><i
            class="icon fa fa-sign-out fa-fw" aria-hidden="true"></i>{{
              $t(LangConstants.logout_dropdown_link_title)
            }}</b-dropdown-item>
        <b-dropdown-item :href="this.$store.getters.instanceUrl + '/course/switchrole.php?id=1'"><i
            class="icon fa fa-user-secret fa-fw" aria-hidden="true"></i>{{
              $t(LangConstants.switch_role_dropdown_link_title)
            }}</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import "../../assets/scss/header.scss";
//import MyButton from "../atoms/Button.vue";
import Common from "../../functions/index";
import Constants from "../../constants/index";

export default {
  name: "my-header",

  data() {
    return {
      stepsIndex: 0,
      searchBarOpen: false,
      cpwStep: 1,
      wpwStep: 1,
      isParticipantActionEnabled: false,
      disabledStep: 0,
      menuItems: null,
      menuItemRowCount: 0
    };
  },

  created() {
    const authUser = this.$store.getters.getAuthUser;
    if (authUser != null) {
      const userid = authUser.userid;
      let menuItemsApiUrl = this.$store.getters.instanceUrl + "/local/sparkfore_api/resource.php?get=menuitems&userid=" + userid;
      let result = Common.httpGet(menuItemsApiUrl);
      result = JSON.parse(result);
      if (result.success == true) {
        this.menuItems = result.data;
        let rowcount = 0;
        this.menuItems.forEach((menurow) => {
          if (menurow.items.length > rowcount) {
            rowcount = menurow.items.length;
          }
        });
        this.menuItemRowCount = rowcount;
      }
    }
    if (this.$route.query.participant_view) {
      this.isParticipantActionEnabled = true;
    }
  },

  mounted() {
    this.$root.$on("company-payment-wizard-step", (step) => {
      this.cpwStep = step;
    });
    this.$root.$on("webshop-payment-wizard-step", (step) => {
      this.wpwStep = step;
    });
    this.$root.$on("webshop-payment-wizard-isablde-step", (step) => {
      this.disabledStep = step;
    });
  },

  computed: {
    applicationLogo() {
      let logoApiUrl = this.$store.getters.instanceUrl + "/local/sparkfore_api/resource.php?get=logo";
      let result = Common.httpGet(logoApiUrl);
      result = JSON.parse(result);

      if (result.success == true) {
        return result.data;
      } else {
        var images = require.context("../../assets/imgs/", false, /\.png$/);
        return images("./logo.png");
      }
    },

    isPublicRoute() {
      const publicRoutes = this.$store.getters.allPublicRoutes;
      return publicRoutes.includes(this.$route.name);
    },

    isHeaderShown() {
      const headerHiddenPublicRoutes = this.$store.getters.allHeaderHiddenPublicRoutes;
      return !headerHiddenPublicRoutes.includes(this.$route.name);
    },

    username() {
      const authUser = this.$store.getters.getAuthUser;
      if (authUser != null) {
        return authUser.first_name + " " + authUser.last_name;
      }

      return "User";
    },

    userinitials() {
      const authUser = this.$store.getters.getAuthUser;
      if (authUser != null) {
        return authUser.first_name[0] + authUser.last_name[0];
      }

      return "User";
    },

    authUserImage() {
      const authUser = this.$store.getters.getAuthUser;

      if ((authUser != null && isNaN(parseInt(authUser.picture))) || (authUser.picture != "" && isNaN(parseInt(authUser.picture)))) {
        return authUser.picture;
      }

      return false;
    },

    menuItemContainerClass() {
      console.log(this.menuItemRowCount);
      switch(this.menuItemRowCount) {
        case 1:
          return "menu-item-container menu-item-container-1";
        case 2:
          return "menu-item-container menu-item-container-2";
        case 3:
          return "menu-item-container menu-item-container-3";
        default:
          return "menu-item-container menu-item-container-4";
      }
    },

    menuItemClass() {
      switch(this.menuItemRowCount) {
        case 1:
          return "col-12 menu-item mb-3";
        case 2:
          return "col-6 menu-item mb-3";
        case 3:
          return "col-4 menu-item mb-3";
        default:
          return "col-3 menu-item mb-3";
      }
    },

    LangConstants() {
      return Constants;
    },
    completedwpwStep() {
      return (step) => {
        return step <= this.wpwStep
      }
    },
    completedcpwStep() {
      return (step) => {
        return step <= this.cpwStep
      }
    }
  },

  components: {
    //MyButton,
  },

  props: {

    user: {
      type: Object,
    },
  },

  methods: {
    onClick() {
      this.$root.$emit("header:ToggleSidebar");
    },
    toggleSearchBar() {
      this.searchBarOpen = !this.searchBarOpen;
      this.$refs["searchBarInput"].focus();
      this.redirectToSearch();
    },
    handleInputOnEnter() {
      this.redirectToSearch();
    },
    redirectToSearch() {
      let searchText = this.$refs.searchBarInput.vModelValue;

      if (searchText) {
        const redirectURL = this.$store.getters.instanceUrl + "/search/index.php?context=1&q=" + encodeURI(searchText);
        window.location.href = redirectURL;
        this.$refs.searchBarInput.vModelValue = "";
      }
    },
    getMenuItemUrl(path) {
      return this.$store.getters.instanceUrl + path[0] == "/" ? path.substring(1,path.length) : path;
    },
    getMenuItemIcon(faicon) {
      return "fa fa-"+faicon;
    }
  },

  emits: ["login", "logout", "createAccount"],
};
</script>
